import { useQuery } from '@tanstack/react-query';
import type { ElasticBranding } from '@//app/api/search/brandings';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetJson } from '../../httpClient';

export const BRANDINGS_CACHE_KEY = 'api/search/brandings';

const useBrandings = () => {
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<ElasticBranding[]>({
    queryKey: [BRANDINGS_CACHE_KEY],
    queryFn: async () => {
      const url = `${apiBaseUrl}/api/search/brandings`;
      return await httpClientGetJson<ElasticBranding[]>(url);
    },
  });

  return query;
};

export default useBrandings;
